import { Outlet } from 'react-router-dom';

export function LabelPerfPageLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

LabelPerfPageLayout.displayName = 'LabelPerfPageLayout';
